import { render } from "./Sample.vue?vue&type=template&id=815d4ed4&scoped=true"
import script from "./Sample.vue?vue&type=script&lang=js"
export * from "./Sample.vue?vue&type=script&lang=js"

import "./Sample.vue?vue&type=style&index=0&id=815d4ed4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-815d4ed4"]])

export default __exports__